import { CATEGORY_MAP } from '../constants/categories';
import { EVENT_TYPE_MAP, REMOVED_EVENT_TYPES } from '../constants/eventTypes';

function dbVendorToApp(v) {
  const m = v.metadata || {};
  return {
    id:                v.id,
    userId:            v.user_id || null,
    name:              v.name,
    category:          CATEGORY_MAP[v.category] || v.category,
    allCategories:     (m.allCategories || [v.category]).map(c => CATEGORY_MAP[c] || c),
    subcategories:     v.subcategories  || [],
    homeZip:           v.home_zip,
    radius:            v.radius,
    emoji:             v.emoji          || "🏪",
    tags:              v.tags           || [],
    price:             v.price          || "",
    description:       v.description    || "",
    insurance:         v.insurance      || false,
    hasMinPurchase:    v.has_min_purchase    || false,
    minPurchaseAmt:    v.min_purchase_amt    || 0,
    chargesPrivateFee: v.charges_private_fee || false,
    privateEventFee:   v.private_event_fee   || 0,
    matchScore:        100,
    contactName:       v.contact_name   || "",
    contactEmail:      v.contact_email  || "",
    contactPhone:      v.contact_phone  || "",
    website:           v.website        || "",
    instagram:         v.instagram      || "",
    facebook:          m.facebook       || "",
    tiktok:            m.tiktok         || "",
    youtube:           m.youtube        || "",
    otherSocial:       m.otherSocial    || "",
    photoUrls:         m.photoUrls      || [],
    lookbookUrl:       m.lookbookUrl    || "",
    yearsActive:       m.yearsActive    || "",
    setupTime:         m.setupTime      || "",
    tableSize:         m.tableSize      || "",
    needsElectric:     m.needsElectric  || false,
    responseTime:      m.responseTime   || "",
    bookingLeadTime:   m.bookingLeadTime|| "",
    eventFrequency:    m.eventFrequency || "",
    isServiceProvider: m.isServiceProvider || false,
    vendorType:        m.vendorType     || null,
    serviceCategories: m.serviceCategories || [],
    serviceSubcategories: m.serviceSubcategories || [],
    serviceType:       m.serviceType    || "",
    serviceRateMin:    m.serviceRateMin || "",
    serviceRateMax:    m.serviceRateMax || "",
    serviceRateType:   m.serviceRateType|| "fixed",
    minBookingDuration:m.minBookingDuration || "",
    serviceDescription:m.serviceDescription || "",
    availabilityNotes: m.availabilityNotes || "",
    equipmentNotes:    m.equipmentNotes    || "",
    foundingVendor:    v.founding_vendor    || false,
    rejectionReason:   v.rejection_reason   || "",
  };
}

function dbEventToApp(e) {
  return {
    id:               e.id,
    eventName:        e.event_name,
    orgName:          e.org_name || '',
    eventType:        EVENT_TYPE_MAP[e.event_type] || (REMOVED_EVENT_TYPES.includes(e.event_type) ? 'Community Festival' : e.event_type),
    eventTypes:       (e.event_types && e.event_types.length > 0)
      ? e.event_types.map(t => EVENT_TYPE_MAP[t] || t)
      : [EVENT_TYPE_MAP[e.event_type] || (REMOVED_EVENT_TYPES.includes(e.event_type) ? 'Community Festival' : e.event_type)].filter(Boolean),
    zip:              e.zip,
    date:             e.date,
    startTime:        e.start_time ? e.start_time.slice(0, 5) : "",
    endTime:          e.end_time   ? e.end_time.slice(0, 5)   : "",
    boothFee:         e.booth_fee         || "",
    spots:            e.spots             || 0,
    categoriesNeeded: (e.categories_needed || []).map(c => CATEGORY_MAP[c] || c),
    contactName:      e.contact_name      || "",
    contactEmail:     e.contact_email     || "",
    contactPhone:     e.contact_phone     || "",
    fbLink:           e.event_link || e.fb_link || "",
    deadline:         e.deadline          || "",
    notes:            e.notes             || "",
    vendorNotes:      e.vendor_notes      || "",
    eventGoerNotes:   e.event_goer_notes  || "",
    shareWithEventGoers: e.share_with_event_goers !== false,
    source:           e.source            || "Host Submitted",
    photoUrl:         e.photo_url         || "",
    vendorDiscovery:  e.vendor_discovery  || "both",
    allowDuplicateCategories: e.allow_duplicate_categories !== false,
    allowDuplicateSubcategories: e.allow_duplicate_subcategories !== false,
    status:           e.status            || "approved",
    vendorStatus:     e.vendor_status     || "open",
    eventLink:        e.event_link        || "",
    vendorLink:       e.vendor_link       || "",
    isTicketed:       e.is_ticketed       || false,
    ticketPrice:      e.ticket_price      || "",
    userId:           e.user_id           || "",
    adminNotes:       e.admin_notes       || "",
    rejectionReason:  e.rejection_reason  || "",
    servicesNeeded:   (() => { try { return typeof e.services_needed === 'string' ? JSON.parse(e.services_needed) : (e.services_needed || []); } catch { return []; } })(),
    eventPhotos:      e.event_photos || [],
  };
}

export { dbVendorToApp, dbEventToApp };
